<template>
    <div class="channels-tab">
        <div class="channels-description">
            <div>
                <strong>Этот раздел нужен, чтобы сообщения точно доходили до клиентов.</strong><br>
                <ol type="number">
                    <li>Каждая строка — это канал (WhatsApp, Telegram и др.).</li>
                    <li>
                        Каждый столбец — тип сообщений: маркетинговые, сервисные
                        <span v-if="hasYClientsAndBotConnector"> и коды подтверждения (YCLIENTS)</span>.
                    </li>
                    <li>Укажите приоритет каналов (1 → 2 → 3). Если канал с Приоритетом 1 недоступен, мы перейдем к следующему.</li>
                </ol>
                <strong>Так клиент гарантированно получит сообщение, даже если один из каналов недоступен.</strong>
            </div>
        </div>
        <template v-if="project?.billingEnabled && project?.isChannelsSlots">
            <ChannelsTable
                :connectors="channels"
                :allChannelsCards="allChannelsCards"
                :channel-priorities="channelPriorities"
                @openConnectorSettingsInSidebar="handleOpenConnectorSettingsInSidebar"
                @update-channel-priority="handleChannelPriorityUpdate"
            />
            <ChannelsTable
                v-if="project?.isCustomCascades"
                variant="custom-cascades"
                :connectors="channels"
                :allChannelsCards="allChannelsCards"
                @openConnectorSettingsInSidebar="handleOpenConnectorSettingsInSidebar"
            />
        </template>
        <ConnectorsListView
            v-else
            :connectors="channels"
            :allChannelsCards="allChannelsCards"
            :value="selectedConnectors"
            :channel-priorities="channelPriorities"
            @input="handleSelectedConnectorsUpdate"
            @openConnectorSettings="handleOpenConnectorSettings"
            @openConnectorSettingsInSidebar="handleOpenConnectorSettingsInSidebar"
            @deleteConnector="handleDeleteConnector"
            @update-channel-priority="handleChannelPriorityUpdate"
        />
        <!-- <ChannelsPromoBlocks
            v-if="project?.billingEnabled && project?.isChannelsSlots"
            :project="project"
            class="mt-3"
        /> -->
        <ChannelsSmsPromoBanner :project="project" />
        <ChannelsSecondChannelPromoBanner
            v-if="project?.billingEnabled && project?.isChannelsSlots"
            :project-id="project.id"
            class="mt-3"
        />
    </div>
</template>

<script>
import { checkRole } from '../../helpers/roles'
import ChangeViewBtn from '@/components/buttons/ChangeViewBtn'
import ConnectorCard from './ConnectorCard'
import InactiveChannelCard from './InactiveChannelCard.vue'
import ConnectorsListView from './ConnectorsListView'
import ChannelsTable from './ChannelsTable.vue'
import ChannelsPromoBlocks from './ChannelsPromoBlocks.vue'
import ChannelsSecondChannelPromoBanner from './ChannelsSecondChannelPromoBanner.vue'
import ChannelsSmsPromoBanner from './ChannelsSmsPromoBanner.vue'

export default {
    name: 'ChannelsTab',
    components: {
        ChangeViewBtn,
        ConnectorCard,
        InactiveChannelCard,
        ConnectorsListView,
        ChannelsTable,
        ChannelsPromoBlocks,
        ChannelsSecondChannelPromoBanner,
        ChannelsSmsPromoBanner,
    },
    props: {
        project: {
            type: Object,
            required: true,
        },
        channels: {
            type: Array,
            required: true,
        },
        allChannelsCards: {
            type: Array,
            required: true,
        },
        selectedConnectors: {
            type: Array,
            default: () => [],
        },
        channelPriorities: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        checkRole,
        handleSelectedConnectorsUpdate(value) {
            this.$emit('update:selectedConnectors', value)
        },
        handleOpenConnectorSettings(connectorId) {
            this.$emit('openConnectorSettings', connectorId)
        },
        handleOpenConnectorSettingsInSidebar(connectorId) {
            this.$emit('openConnectorSettingsInSidebar', connectorId)
        },
        handleDeleteConnector(connectorId) {
            this.$emit('deleteConnector', connectorId)
        },
        handleChannelPriorityUpdate({ connectorId, type, priority }) {
            this.$emit('update-channel-priority', { connectorId, type, priority })
        },
    },
    computed: {
        hasYClientsAndBotConnector() {
            const connectors = this.project?.connectors || []
            const hasY = connectors.some((c) => c.connectorType === 'yClients')
            const hasBot = connectors.some((c) => c.connectorType === 'whatsappBasis')
            return Boolean(hasY && hasBot)
        },
    },
}
</script>

<style scoped>
.channels-tab {
    margin-top: 16px;
}

.channels-description {
    margin-bottom: 24px;
}

.channels-description p {
    font-size: 14px;
    line-height: 1.6;
    color: rgba(0, 0, 0, 0.87);
    margin: 0;
}

</style>

